import { PAYMENT_METHODS, SERVICES } from '@autopass-web/domain';

import type {
  ConfirmPaymentInfo,
  PaymentInfo,
  Receipt,
} from '#/guest-aps/services/payments/types';

import Client from '#/guest-aps/services/client';

interface CreateTaiwanPaySessionProps {
  paymentInfo: PaymentInfo;
  receipt: Receipt;
  email: string | undefined;
}

export const createTaiwanPaySession = async ({
  paymentInfo,
  receipt,
  email,
}: CreateTaiwanPaySessionProps) => {
  const callbackUrlParams = new URLSearchParams({
    paymentType: PAYMENT_METHODS.TAIWAN_PAY,
    serviceType: SERVICES.APS,
    parkingTicketId: paymentInfo.id,
    plateNumber: paymentInfo.plateNumber,
  });

  const callbackUrl = `${
    window.location.origin
  }/auth?${callbackUrlParams.toString()}`;

  const { data } = await Client.createWalletSession({
    callbackUrl,
    parkingTicketId: paymentInfo.id,
    email,
    receipt,
    walletType: 'taiwan_pay',
  });

  return data.data.redirect_link;
};

interface ConfirmTaiwanPayTransactionProps {
  confirmPaymentInfo: ConfirmPaymentInfo;
}

export const confirmTaiwanPayTransaction = async ({
  confirmPaymentInfo,
}: ConfirmTaiwanPayTransactionProps) => {
  const { data } = await Client.authApsWalletPay({
    transactionId: confirmPaymentInfo.merchantTransactionId,
    walletType: 'taiwan_pay',
  });

  return data;
};
